import { render, staticRenderFns } from "./QueryOverviewTableAnswer.vue?vue&type=template&id=cd0885fa&scoped=true"
import script from "./QueryOverviewTableAnswer.vue?vue&type=script&lang=ts"
export * from "./QueryOverviewTableAnswer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd0885fa",
  null
  
)

export default component.exports